<template>
  <fin-data-loader :resolver="query"
                   class="documents"
                   overlay>
    <template #content="{data}">
      <div>

        <fin-my-profile-block title="Regulatorische Dokumente" protected>
          <fin-lexicon-link class="lexicon-link" to="bafin_regulation">Was sind das für Dokumente und warum muß ich sie
            bestätigen?
          </fin-lexicon-link>
          <br/>
          <fin-regulation-document-downloads :documents="data" v-if="data" protected/>
        </fin-my-profile-block>
      </div>
    </template>
  </fin-data-loader>
</template>

<script>
import FinMyProfileBlock from "@/components/pages/profile/MyProfileBlock"
import FinDataLoader from "@/components/common/DataLoader"
import FinRegulationDocumentDownloads from "@/components/common/DocumentDownloads/RegulationDocumentDownloads"
import {mapGetters} from "vuex"
import {graphqlOperation} from "@/plugins/finAmplifyModules"
import FinLexiconLink from "@/components/common/lexicon/LexiconLink"

const query = `
query documentsToShow($id: ID!){
  getUser(id:$id){
      documents{
        documentId
        acceptedAt
        isPrivate
        version
        comment
        fileName
        createdAt
        updatedAt
      }
  }
}
`


export default {
  name: "FinUserDocuments",
  components: {FinLexiconLink, FinRegulationDocumentDownloads, FinDataLoader, FinMyProfileBlock},
  computed: {
    ...mapGetters('auth', ['userId']),

  },
  methods: {
    query() {
      return {
        key: 'myDocuments',
        load: () => graphqlOperation(query, {id: this.userId}),
        adapt: ({getUser: data}) => data.documents
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
